import axios from 'axios';

const baseUrl = id => `/api/v1/wire/${id}/keyword`;

export function getWireKws(id) {
  return axios.get(`${baseUrl(id)}s`, { cache: { ignoreCache: true } });
}

export function addKw(wireId, kwSlug) {
  return axios.post(`${baseUrl(wireId)}/${kwSlug}`);
}

export function removeKw(wireId, kwSlug) {
  return axios.delete(`${baseUrl(wireId)}/${kwSlug}`);
}
